// merchant.mock.ts

export const COMPANIES = [
  {
    createdAt: new Date().toISOString(),
    email: "company1@example.com",
    id: "1",
    logo: "https://example.com/logo1.png",
    name: "Company 1",
    phone: "1234567890",
    updatedAt: new Date().toISOString(),
    userCompanies: []
  },
  {
    createdAt: new Date().toISOString(),
    email: "company2@example.com",
    id: "2",
    logo: "https://example.com/logo2.png",
    name: "Company 2",
    phone: "0987654321",
    updatedAt: new Date().toISOString(),
    userCompanies: []
  },
  // Add more companies as needed
];

//company.mock.ts
